/** The cards and journey header finish moving before step 1 enters. */
export const PICKER_STACK_SETTLE_DURATION_S = 0.55;
/** Animate position only: FLIP size scaling visibly stretches tile icons and copy. */
export const PICKER_HANDOFF_LAYOUT_MODE = "position" as const;

function readNavHeightPx(): number {
	if (typeof window === "undefined") return 72;
	const root = document.documentElement;
	const raw = getComputedStyle(root).getPropertyValue("--landing-nav-height").trim();
	if (!raw) return 72;
	if (raw.endsWith("rem")) {
		const rem = Number.parseFloat(raw);
		const fontSize = Number.parseFloat(getComputedStyle(root).fontSize) || 16;
		return rem * fontSize;
	}
	return Number.parseFloat(raw) || 72;
}

export function resolvePickerStackTop({
	viewportHeight,
	headerHeight,
	navHeight,
	isMobile,
	cardsVisible,
	settled,
}: {
	viewportHeight: number;
	headerHeight: number;
	navHeight: number;
	isMobile: boolean;
	cardsVisible: boolean;
	settled: boolean;
}): number {
	if (settled) return navHeight;
	if (!cardsVisible) return Math.max(navHeight, viewportHeight / 2 - headerHeight / 2);
	return isMobile ? Math.max(56, Math.min(viewportHeight * 0.19, 160)) : Math.max(88, viewportHeight * 0.22);
}

export function measurePickerStackTop({
	headerHeight,
	cardsVisible,
	settled,
}: {
	headerHeight: number;
	cardsVisible: boolean;
	settled: boolean;
}): number {
	if (typeof window === "undefined") return settled ? 72 : 176;
	return resolvePickerStackTop({
		viewportHeight: window.innerHeight,
		headerHeight,
		navHeight: readNavHeightPx(),
		isMobile: window.matchMedia("(max-width: 1023px)").matches,
		cardsVisible,
		settled,
	});
}
